//userprofile vuex module

const userProfileVuex = {
  namespaced: true,
  state: {
    username: "",
    useremail: "",
    userImage: "",
    datasets: [],
    areas: [],
    custgroups: [],
    nkagroups: [],
    custs: [],
    prods: [],
    branches: [],
    roles: []
  },
  mutations: {
    setUsername(state, val) {
      state.username = val;
    },
    setUseremail(state, val) {
      state.useremail = val;
    },
    setUserimage(state, val) {
      state.userImage = val;
    },
    setDatasets(state, val) {
      state.datasets = val;
    },
    setAreas(state, val) {
      state.areas = val;
    },
    setCustgroups(state, val) {
      state.custgroups = val;
    },
    setNkagroups(state, val) {
      state.nkagroups = val;
    },
    setCusts(state, val) {
      state.custs = val;
    },
    setProds(state, val) {
      state.prods = val;
    },
    setBranches(state, val) {
      state.branches = val;
    },
    setRoles(state, val) {
      state.roles = val;
    }
  },
  actions: {
    setUsername({ commit }, val) {
      commit("setUsername", val);
    },
    setUseremail({ commit }, val) {
      commit("setUseremail", val);
    },
    setUserimage({ commit }, val) {
      commit("setUserimage", val);
    },
    setDatasets({ commit }, val) {
      commit("setDatasets", val);
    },
    setAreas({ commit }, val) {
      commit("setAreas", val);
    },
    setCustgroups({ commit }, val) {
      commit("setCustgroups", val);
    },
    setNkagroups({ commit }, val) {
      commit("setNkagroups", val);
    },
    setCusts({ commit }, val) {
      commit("setCusts", val);
    },
    setProds({ commit }, val) {
      commit("setProds", val);
    },
    setBranches({ commit }, val) {
      commit("setBranches", val);
    },
    setRoles({ commit }, val) {
      commit("setRoles", val);
    }
  },
  modules: {}
};

export default userProfileVuex;
